<div class="entries-table-container">
  <div class="container-header">
    SHOW ENTRY PAYMENTS HISTORY
  </div>

  @if(entriesTable.length) {

    <table mat-table [dataSource]="entriesTable">
      <ng-container matColumnDef="showId">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>
          SHOW ID
        </th>
        <td mat-cell *matCellDef="let line">
          <div class="id-text cell-content">{{ line.showId }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="showName">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>
          SHOW NAME
        </th>
        <td mat-cell *matCellDef="let line">
          <div class="id-text cell-content">{{ line.showName }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="timestamp">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>
          DATE
        </th>
        <td mat-cell *matCellDef="let line">
          <div class="cell-content">{{ line.timestamp | timestamp | date:'medium' }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>TOTAL PAID</th>
        <td mat-cell *matCellDef="let line">
          <div class="cell-content">
            {{ line.numberOfEntries ? 'Entries: ' + line.numberOfEntries : ''}}
            {{ line.numberOfBooklets ? ' | Booklets: ' + line.numberOfBooklets : ''}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>TOTAL PAID</th>
        <td mat-cell *matCellDef="let line">
          <div class="cell-content">{{ line.total | amount | currency }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Details
        <th>
        <td mat-cell *matCellDef="let line">
          <button mat-button (click)="openDetailsDialog(line)" color="primary" class="btn-details">
            Details
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="totalLines" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="onPaginationChange($event)" showFirstLastButtons aria-label="Select page of show entry payments">
    </mat-paginator>
  }
  @else {
    <div class="no-data-container">
      <div class="no-data-text">No entries found</div>
    </div>
  }
</div>